import { useEffect, useState } from "react"

import { getMyPhotoBlob } from "@/lib/api"

/**
 * Object URL of the signed-in user's Microsoft 365 profile photo, or null while loading
 * and when they have none (callers show initials). Refetched when `username` changes.
 */
export function useUserPhoto(username: string | null): string | null {
  const [url, setUrl] = useState<string | null>(null)

  useEffect(() => {
    if (!username) return
    let cancelled = false
    let objectUrl: string | null = null
    getMyPhotoBlob().then((blob) => {
      if (cancelled || !blob) return
      objectUrl = URL.createObjectURL(blob)
      setUrl(objectUrl)
    })
    return () => {
      cancelled = true
      if (objectUrl) URL.revokeObjectURL(objectUrl)
      setUrl(null)
    }
  }, [username])

  return url
}
